export const LOAD = 'USER:LOAD'
export const CLEAR = 'USER:CLEAR'
